import { LeaveReasonType } from './interfaces/Users';

interface EmployeeSoftDeleteParams {
	userId: string;
	companyLeaveDate?: string;
	leaveReason?: LeaveReasonType;
	/** Contacto personal que el admin registra en la baja si el perfil aún no lo tiene */
	personalEmail?: string;
	phone?: string;
}

interface EmployeeSoftDeleteResponse {
	success?: boolean;
	error?: string;
	message?: string;
	data?: any;
}

const employeeSoftDelete = async (
	token: string,
	params: EmployeeSoftDeleteParams
): Promise<EmployeeSoftDeleteResponse> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/employee-soft-delete`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(params)
	});

	if (!response.ok) {
		const errorData = await response.json().catch(() => ({}));
		throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
	}

	const data: EmployeeSoftDeleteResponse = await response.json();

	// `AllExceptionFilter` de comparsa responde 200 a todo lo que no sea un 500, con
	// `{success:false, code, message}` en el cuerpo. Sin este control, un 409 por correo
	// personal duplicado se leía como éxito: toast de baja correcta y modal cerrado sin
	// que la baja se hubiera ejecutado.
	if (data.success === false) {
		throw new Error(data.message || 'Error al procesar la baja');
	}

	return data;
};

export default employeeSoftDelete;
